<loading-bar *ngIf="loading"></loading-bar>

<h4 *ngIf="!loading && !customer">No customer information available</h4>

<div *ngIf="customer" class="details-section">
  <div class="section-header">Customer Details</div>
  <div class="section-tab">
    <div class="row">
      <div class="col1">GUID:</div>
      <div class="col">{{ customer.guid }}</div>
    </div>
    <div class="row">
      <div class="col1" matTooltip="Customer Site Name">Legal Customer Name:</div>
      <div class="col">{{ customer.legalName }}</div>
    </div>
    <div class="row">
      <div class="col1" matTooltip="Customer site local name">Legal Customer Name (Local):</div>
      <div class="col">{{ customer.localLegalName }}</div>
    </div>
    <div class="row">
      <div class="col1" matTooltip="Level in the family tree">Company's Family Tree Level:</div>
      <div class="col">{{ customer.familyTreeLevel }}</div>
    </div>
    <div class="row">
      <div class="col1" matTooltip="Type of business partner">Business Partner Type:</div>
      <div class="col">{{ customer.businessPartnerType }}</div>
    </div>
    <div class="row">
      <div class="col1" matTooltip="ABB account classification">Account Type:</div>
      <div class="col">{{ customer.accountType }}</div>
    </div>
    <div class="row">
      <div class="col1">Channel:</div>
      <div class="col">{{ customer.channel }}</div>
    </div>
    <div class="row">
      <div class="col1">Industry Usage:</div>
      <div class="col">{{ customer.industryUsage }}</div>
    </div>
    <div class="row">
      <div class="col1">Active:</div>
      <div class="col">{{ customer.active ? 'Yes' : 'No' }}</div>
    </div>
    <div class="row">
      <div class="col1">Status:</div>
      <div class="col">{{ customer.status }}</div>
    </div>
  </div>
</div>

<div *ngIf="customer && customer.address && customer.address.length > 0">

 <div  class="details-section" *ngFor="let address of customer.address">
  <div class="section-header">Address{{ address.addressType!=null? '&nbsp;('+address.addressType+')':'' }}:</div>
  <div class="section-tab" >
    <div class="row">
      <div class="col1">Street:</div>
      <div class="col">{{ address.street }}</div>
    </div>
    <div class="row">
      <div class="col1">City:</div>
      <div class="col">{{ address.city }}</div>
    </div>
    <div class="row">
      <div class="col1">Zip Code:</div>
      <div class="col">{{ address.zipCode }}</div>
    </div>
    <div class="row">
      <div class="col1">Country:</div>
      <div class="col">{{ address.country }}</div>
    </div>
  </div>
</div> 

</div>